"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "invoices",
    path: "/invoices",
    component: "Invoices",
    params: [{
            name: "kind",
            prop: "kind",
        },
    ]
});
(0, core_1.addRoute)({
    name: "invoicesIn",
    path: "/invoices-in",
    component: "Invoices",
    componentProps: [{
            name: "kind",
            value: "incoming",
        },
    ]
});
(0, core_1.addRoute)({
    name: "invoicesOut",
    path: "/invoices-out",
    component: "Invoices",
    componentProps: [{
            name: "kind",
            value: "outgoing",
        },
    ]
});
let Invoices = class Invoices extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getItems(...args) {
        const parameters = this.params;
        return parameters ? this.$fn.fetch('list_invoice', { parameters }) : [];
    }
    invoiceTypeBadgeClass(...args) {
        const [row] = args;
        const cc = this.$config.invoice.types.colorCodes[row.invoice_type];
        return `bg-${cc.bg} text-${cc.text}`;
    }
    onPrintInvoicesPayload(...args) {
        return this.$imodal
            .show({ name: 'PrintInvoices' })
            .then(result => {
            if (!result || result.cancel || !result.value) {
                return;
            }
            return this.selectedItems.map(p => ({
                invoice_id: p.id,
                copies: result.copies,
                printer: result.printer ? result.printer.id : null,
            }));
        });
    }
    kind;
    onKind(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("kind");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    titles;
    selectedItems;
    params;
    gridName;
    async $$load_gridName() {
        return 'invoices.' + this.kind;
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_headerShowReloadButton;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    async $$load_b_2248226175642056_columns() {
        return [{
                field: "company",
                name: this.$fn.pgettext("Invoices", "Company"),
                formatter: {
                    name: "chain",
                    mode: "mapReduce",
                    formatterContext: "item",
                    formatters: [{
                            name: "getvalue",
                            opts: {
                                field: "name",
                                source: "value",
                            },
                        },
                        {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "id",
                            },
                        },
                    ],
                },
            },
            {
                field: "invoice_number",
                name: this.$fn.pgettext("Invoices", "Invoice nr"),
                type: "command",
                formatter: [{
                        name: "chain",
                        formatters: [{
                                name: "template",
                                engine: "hb",
                                format: "#!{{ $value }} {{~#if reference_number }} ({{ reference_number }}){{~/if }}",
                            },
                            {
                                name: "routeLink",
                                to: "invoice",
                                params: {
                                    id: "id",
                                },
                            },
                            {
                                name: "cellclass",
                                value: (row) => ({
                                    'font-weight-bold': true,
                                    'bg-yellow-200': !row.locked,
                                    'bg-yellow-500 text-yellow-800': row.is_corrected,
                                    'bg-red-300 text-red-800': row.is_reversed,
                                }),
                            },
                        ],
                    },
                ],
            },
            {
                field: "data_reporting_status",
                name: this.$fn.pgettext("Invoices", "NAV"),
                type: "command",
                formatter: {
                    name: "template",
                    engine: "hb",
                    format: "<span>\n\
  {{~#if $value }}\n\
    {{~#if (eq $value.status \"done\") }}\n\
      <iconify-icon icon=\"fluent:cloud-sync-complete-16-regular\" class=\"text-green-500\">\n\
      </iconify-icon>\n\
    {{~else }}\n\
      {{~#if $value.status }}\n\
        <iconify-icon icon=\"fluent:warning-12-filled\" class=\"text-yellow-500\" title=\"{{ $value.status }}\">\n\
        </iconify-icon>\n\
      {{~/if }}\n\
    {{~/if }}\n\
\n\
    {{~#if $value.message }}\n\
      <iconify-icon icon=\"fluent:warning-12-filled\" class=\"text-yellow-500\" title=\"{{ $value.message }}\">\n\
      </iconify-icon>\n\
    {{~/if }}\n\
  {{~/if }}\n\
</span>\n\
",
                },
            },
            {
                field: "invoice_type",
                name: this.$fn.pgettext("Invoices", "Type"),
                formatter: {
                    name: "chain",
                    formatters: [{
                            name: "gettext",
                            context: "InvoiceType",
                            conversion: "StartCase",
                            filterInput: true,
                        },
                        {
                            name: "badge",
                            dot: true,
                            pill: true,
                            badgeClass: this.invoiceTypeBadgeClass,
                        },
                    ],
                },
            },
            {
                field: "invoice_status",
                name: this.$fn.pgettext("Invoices", "Status"),
                formatter: {
                    name: "chain",
                    formatters: [{
                            name: "gettext",
                            context: "Status",
                            conversion: "StartCase",
                            filterInput: true,
                        },
                        {
                            name: "badge",
                            variantmap: this.$config.invoice.invoiceStatusVariants,
                            variantMapSource: "fieldValue",
                        },
                    ],
                },
            },
            {
                field: "printout",
                name: this.$fn.pgettext("Invoices", "Printout"),
                type: "command",
                formatter: {
                    name: "attachment",
                },
            },
            {
                field: "attachments",
                name: this.$fn.pgettext("Invoices", "Attachments"),
                type: "command",
                formatter: {
                    name: "attachment",
                },
            },
            {
                field: "register_entry",
                name: this.$fn.pgettext("Invoices", "Register entry"),
                type: "command",
                params: {
                    sortPath: "register_entry.entry_number",
                },
                formatter: {
                    name: "chain",
                    mode: "mapReduce",
                    separator: ", ",
                    formatterContext: "item",
                    formatters: [{
                            name: "getvalue",
                            opts: {
                                field: "entry_number",
                                source: "value",
                            },
                        },
                        {
                            name: "link",
                            href: "#",
                        },
                        {
                            name: "cellclass",
                            value: (value) => ({
                                'font-weight-bold': true,
                                'bg-yellow-200': value && !value.locked
                            }),
                        },
                    ],
                },
            },
            {
                field: "vat_period",
                name: this.$fn.pgettext("Invoices", "VAT period"),
                type: "command",
                formatter: [{
                        name: "chain",
                        formatters: [{
                                name: "template",
                                engine: "hb",
                                format: "#!{{ $value.name }}",
                            },
                        ],
                    },
                ],
            },
            {
                field: "invoice_date",
                name: this.$fn.pgettext("Invoices", "Date"),
            },
            {
                field: "fulfillment_date",
                name: this.$fn.pgettext("Invoices", "Fulfillment date"),
                type: "date",
            },
            {
                field: "due_date",
                name: this.$fn.pgettext("Invoices", "Due date"),
                type: "date",
            },
            {
                field: "client_name",
                name: this.$fn.pgettext("Invoices", "Client"),
                formatter: {
                    name: "routeLink",
                    to: "company",
                    navigateOnIconClick: true,
                    params: {
                        id: "client_id",
                    },
                },
            },
            {
                field: "description",
                name: this.$fn.pgettext("Invoices", "Description"),
            },
            {
                field: "net_total",
                name: this.$fn.pgettext("Invoices", "Net"),
                type: "number",
                formatter: "number",
            },
            {
                field: "vat_total",
                name: this.$fn.pgettext("Invoices", "VAT"),
                type: "number",
                formatter: "number",
            },
            {
                field: "total",
                name: this.$fn.pgettext("Invoices", "Total"),
                type: "number",
                formatter: "number",
            },
            {
                field: "paid",
                name: this.$fn.pgettext("Invoices", "Paid"),
                type: "number",
                formatter: "number",
            },
            {
                field: "unpaid",
                name: this.$fn.pgettext("Invoices", "Claim"),
                type: "number",
                formatter: {
                    name: "chain",
                    formatters: [{
                            name: "number",
                        },
                        {
                            name: "cellclass",
                            value: (row) => {
                                if (row.flags && row.flags.no_payment_required) {
                                    return 'font-weight-bold text-decoration-line-through';
                                }
                                if (row.unpaid != null && row.unpaid > 0) {
                                    return 'font-weight-bold text-red-500';
                                }
                                if (row.unpaid != null && row.unpaid < 0) {
                                    return 'font-weight-bold text-blue-500';
                                }
                                if (row.unpaid == 0) {
                                    return 'font-weight-bold text-green-500';
                                }
                            },
                        },
                    ],
                },
            },
            {
                field: "overpayment",
                name: this.$fn.pgettext("InvoicesView", "Overpayment"),
                type: "number",
                formatter: {
                    name: "chain",
                    formatters: [{
                            name: "number",
                        },
                        {
                            name: "cellclass",
                            value: (row) => ({
                                'text-blue-500': row.overpayment != null && row.overpayment > 0,
                            }),
                        },
                    ],
                },
            },
            {
                field: "max_payment_date",
                name: this.$fn.pgettext("PaymentBrowserView", "Date of last settlement"),
                type: "date",
            },
            {
                field: "currency",
                name: this.$fn.pgettext("Invoices", "Currency"),
            },
            {
                field: "vat_deductible",
                if: this.kind === 'incoming',
                name: this.$fn.pgettext("InvoicesView", "VAT deductible"),
                type: "number",
                formatter: "number",
            },
            {
                field: "tags",
                name: this.$fn.pgettext("Invoices", "Tags"),
            },
            {
                field: "rentals",
                name: this.$fn.pgettext("Invoices", "Rentals"),
                params: {
                    sortPath: "rentals.0.name",
                },
                formatter: {
                    name: "chain",
                    mode: "mapReduce",
                    separator: ", ",
                    formatterContext: "value",
                    formatters: [{
                            name: "getvalue",
                            opts: {
                                field: "name",
                                source: "value",
                            },
                        },
                        {
                            name: "routeLink",
                            to: "rental",
                            navigateOnIconClick: true,
                            params: {
                                id: "id",
                            },
                        },
                    ],
                },
            },
            {
                field: "contracts",
                name: this.$fn.pgettext("Invoices", "Contracts"),
                formatter: {
                    name: "chain",
                    mode: "mapReduce",
                    separator: ", ",
                    formatterContext: "value",
                    formatters: [{
                            name: "getvalue",
                            opts: {
                                field: "contract_number",
                                source: "value",
                            },
                        },
                        {
                            name: "routeLink",
                            to: "contract",
                            navigateOnIconClick: true,
                            params: {
                                id: "id",
                            },
                        },
                    ],
                },
            },
            {
                field: "created_at",
                name: this.$fn.pgettext("BrowserColumn", "Create time"),
                formatter: "datetime",
            },
        ];
    }
    dataMembers = ['titles', 'selectedItems', 'params', 'gridName', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_headerShowReloadButton', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                titles: {
                    incoming: this.$fn.pgettext("Invoices", "Vendor invoices"),
                    outgoing: this.$fn.pgettext("Invoices", "Customer invoices"),
                },
                selectedItems: [],
                params: null,
                gridName: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_headerShowReloadButton: false,
                b_2248226175642056_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                    selectable: true,
                },
                b_2248226175642056_columns: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.titles[this.kind],
                icon: this.$config.invoice.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3230_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_3232_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_script_3236_getActionArgs_value($event) {
        this.$refs.grid.reload();
    }
    async act_2248226175642056_script_3236_getActionArgs($event) {
        return {
            value: () => this.act_2248226175642056_script_3236_getActionArgs_value($event),
        };
    }
    async act_2248226175642056_showModal_3234_getActionArgs($event) {
        return {
            name: "RegisterEntry",
            props: {
                oid: $event.data.data.register_entry.id,
            },
        };
    }
    async evh_2248226175642056_command_3233_getWhen($event) {
        return $event.data.column.id === 'register_entry' && $event.data.data.register_entry != null;
    }
    async act_2248226175642056_script_3238_getActionArgs_value($event) {
        this.$app.attachments.downloadAttachmentFromSlickCommand($event);
    }
    async act_2248226175642056_script_3238_getActionArgs($event) {
        return {
            value: () => this.act_2248226175642056_script_3238_getActionArgs_value($event),
        };
    }
    async evh_2248226175642056_command_3237_getWhen($event) {
        return $event.data.column.id === 'attachments';
    }
    async act_2248226175642056_script_3240_getActionArgs_value($event) {
        this.$app.attachments.downloadInvoiceView($event.data.data.id, $event.data.data.invoice_number);
    }
    async act_2248226175642056_script_3240_getActionArgs($event) {
        return {
            value: () => this.act_2248226175642056_script_3240_getActionArgs_value($event),
        };
    }
    async evh_2248226175642056_command_3239_getWhen($event) {
        return $event.data.column.id === 'printout';
    }
    async evh_2248226175642056_command(event, scope) {
        return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
    }
    async act_6466705138206980_setData_3242_getActionArgs($event) {
        return {
            path: "params",
            value: { ...$event.data, kind: this.kind },
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_6466705138206980_script_3244_getActionArgs_value($event) {
        this.$refs.grid.reload();
    }
    async act_6466705138206980_script_3244_getActionArgs($event) {
        return {
            value: () => this.act_6466705138206980_script_3244_getActionArgs_value($event),
        };
    }
    async evh_6466705138206980_submit(event, scope) {
        return await this.actions.evh_6466705138206980_submit.executeFromDOM(this, event, scope);
    }
    async act_8697745105058001_showModal_3246_getActionArgs($event) {
        return {
            name: "CreateInvoice",
            props: {
                invoiceKind: this.kind,
            },
        };
    }
    async evh_8697745105058001_click(event, scope) {
        return await this.actions.evh_8697745105058001_click.executeFromDOM(this, event, scope);
    }
    async act_5382094220310827_showModal_3248_getActionArgs($event) {
        return {
            name: "ImportInvoices",
        };
    }
    async evh_5382094220310827_clickPrevent(event, scope) {
        return await this.actions.evh_5382094220310827_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_2688566256707306_reloadSlickgrid_3252_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async evh_2688566256707306_close_3251_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_2688566256707306_showModal_3250_getActionArgs($event) {
        return {
            name: "SetInvoiceVatPeriod",
            props: {
                invoices: this.selectedItems,
            },
        };
    }
    async evh_2688566256707306_clickPrevent(event, scope) {
        return await this.actions.evh_2688566256707306_clickPrevent.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3230 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3230_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3229 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3230,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3229],
        });
        const act_2248226175642056_setData_3232 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_3232_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_3231 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_3232,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_3231],
        });
        const act_2248226175642056_script_3236 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2248226175642056_script_3236_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_saved_3235 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_script_3236,
            event: "saved",
            displayName: "script",
        });
        const act_2248226175642056_showModal_3234 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_3234_getActionArgs,
            events: [evh_2248226175642056_saved_3235],
        });
        const evh_2248226175642056_command_3233 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_3234,
            event: "command",
            when: this.evh_2248226175642056_command_3233_getWhen,
            displayName: "showModal",
        });
        const act_2248226175642056_script_3238 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2248226175642056_script_3238_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_command_3237 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_script_3238,
            event: "command",
            when: this.evh_2248226175642056_command_3237_getWhen,
            displayName: "script",
        });
        const act_2248226175642056_script_3240 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2248226175642056_script_3240_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_command_3239 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_script_3240,
            event: "command",
            when: this.evh_2248226175642056_command_3239_getWhen,
            displayName: "script",
        });
        const evh_2248226175642056_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_command_3233, evh_2248226175642056_command_3237, evh_2248226175642056_command_3239],
        });
        const act_6466705138206980_setData_3242 = new core_1.actions.SetDataAction({
            actionArgs: this.act_6466705138206980_setData_3242_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_submit_3241 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_setData_3242,
            event: "submit",
            displayName: "setData",
        });
        const act_6466705138206980_script_3244 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6466705138206980_script_3244_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_submit_3243 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_script_3244,
            event: "submit",
            displayName: "script",
        });
        const evh_6466705138206980_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_submit_3241, evh_6466705138206980_submit_3243],
        });
        const act_8697745105058001_showModal_3246 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8697745105058001_showModal_3246_getActionArgs,
            events: [],
        });
        const evh_8697745105058001_click_3245 = new core_1.actions.EventHandlerImpl({
            action: act_8697745105058001_showModal_3246,
            event: "click",
            displayName: "showModal",
        });
        const evh_8697745105058001_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8697745105058001_click_3245],
        });
        const act_5382094220310827_showModal_3248 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5382094220310827_showModal_3248_getActionArgs,
            events: [],
        });
        const evh_5382094220310827_clickPrevent_3247 = new core_1.actions.EventHandlerImpl({
            action: act_5382094220310827_showModal_3248,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_5382094220310827_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5382094220310827_clickPrevent_3247],
        });
        const act_2688566256707306_reloadSlickgrid_3252 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_2688566256707306_reloadSlickgrid_3252_getActionArgs,
            events: [],
        });
        const evh_2688566256707306_close_3251 = new core_1.actions.EventHandlerImpl({
            action: act_2688566256707306_reloadSlickgrid_3252,
            event: "close",
            when: this.evh_2688566256707306_close_3251_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_2688566256707306_showModal_3250 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2688566256707306_showModal_3250_getActionArgs,
            events: [evh_2688566256707306_close_3251],
        });
        const evh_2688566256707306_clickPrevent_3249 = new core_1.actions.EventHandlerImpl({
            action: act_2688566256707306_showModal_3250,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_2688566256707306_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2688566256707306_clickPrevent_3249],
        });
        return {
            act_7315092382398562_closeModal_3230,
            evh_7315092382398562_close_3229,
            evh_7315092382398562_close,
            act_2248226175642056_setData_3232,
            evh_2248226175642056_selectedRowsChanged_3231,
            evh_2248226175642056_selectedRowsChanged,
            act_2248226175642056_script_3236,
            evh_2248226175642056_saved_3235,
            act_2248226175642056_showModal_3234,
            evh_2248226175642056_command_3233,
            act_2248226175642056_script_3238,
            evh_2248226175642056_command_3237,
            act_2248226175642056_script_3240,
            evh_2248226175642056_command_3239,
            evh_2248226175642056_command,
            act_6466705138206980_setData_3242,
            evh_6466705138206980_submit_3241,
            act_6466705138206980_script_3244,
            evh_6466705138206980_submit_3243,
            evh_6466705138206980_submit,
            act_8697745105058001_showModal_3246,
            evh_8697745105058001_click_3245,
            evh_8697745105058001_click,
            act_5382094220310827_showModal_3248,
            evh_5382094220310827_clickPrevent_3247,
            evh_5382094220310827_clickPrevent,
            act_2688566256707306_reloadSlickgrid_3252,
            evh_2688566256707306_close_3251,
            act_2688566256707306_showModal_3250,
            evh_2688566256707306_clickPrevent_3249,
            evh_2688566256707306_clickPrevent,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], Invoices.prototype, "kind", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('kind'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Invoices.prototype, "onKind", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], Invoices.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Invoices.prototype, "onSize", null);
Invoices = __decorate([
    (0, vue_property_decorator_1.Component)()
], Invoices);
exports.default = Invoices;
vue_property_decorator_1.Vue.component("Invoices", Invoices);
